var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('PageIntro',{attrs:{"heading":'Your <span>' +_vm.configStrings.productName + '</span> account',"body":'<p>Your membership has been created, you must now click the verification link contained within an email sent to the email address that you used during the registration.</p>'}}),_c('FooterShout',{attrs:{"type":'register'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }